import React, { useState, useMemo, Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { uid } from '../utils/data';

import css from './Toggle.module.css';

const Toggle = (props) => {
	const { name, value, onChange, className, label, innerLabels, readOnly } = props;

	const id = useMemo(() => uid('toggle'), []);

	const handleOnClick = (e) => {
		if (readOnly) return;
		onChange(name, e.target.checked);
	};

	return (
		<div className={classnames(css.root, { [css.readOnly]: readOnly, [className]: className })}>
			<label htmlFor={id} className={css.label}>
				{label}
			</label>
			<input
				id={id}
				className={css.checkbox}
				type="checkbox"
				checked={value}
				onChange={handleOnClick}
				readOnly={readOnly}
			/>
			<div
				className={classnames(css.toggle, {
					[css.on]: value,
				})}>
				<span className={css.slider} />

				{innerLabels && innerLabels.length == 2 && (
					<span className={css.innerLabels}>
						<span className={css.innerLabel}>{innerLabels[0]}</span>
						<span className={css.innerLabel}>{innerLabels[1]}</span>
					</span>
				)}
			</div>
		</div>
	);
};

export default React.memo(Toggle);
